import { render, staticRenderFns } from "./PostcodeInput.vue?vue&type=template&id=581a0a54&scoped=true"
import script from "./PostcodeInput.vue?vue&type=script&lang=js"
export * from "./PostcodeInput.vue?vue&type=script&lang=js"
import style0 from "./PostcodeInput.vue?vue&type=style&index=0&id=581a0a54&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a0a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581a0a54')) {
      api.createRecord('581a0a54', component.options)
    } else {
      api.reload('581a0a54', component.options)
    }
    module.hot.accept("./PostcodeInput.vue?vue&type=template&id=581a0a54&scoped=true", function () {
      api.rerender('581a0a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form/PostcodeInput.vue"
export default component.exports